import React from 'react'

export function ToolbarSpacer() {
  return <div className="u-grow" />
}
